import React, { useEffect, useState, Suspense, lazy } from 'react';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import './App.css';
import PublicRoute from './router/PublicRoute';
import PrivateRoute from './router/PrivateRoute';

import { useUser } from './auth/UseUser';
import { whoAmI } from './server/server';
import { Toaster } from 'react-hot-toast';
import ServerWakeupModal from './components/common/ServerWakeupModal';
import { useCanonicalSync } from './utils/pageMeta';

// LAYOUTS
import UserHome from './components/user/UserHome';
import Layout from './components/login/Layout';

// AUTH
import LoginScreen from './components/login/LoginScreen';
import VerifyAccount from './components/login/VerifyAccount';
import ResetPassword from './components/login/ResetPassword';

// USER
import Home from './components/home/Home';
import ObrazovanjeHome from './components/obrazovanje/ObrazovanjeHome';
import LekcijaObrazovanjeHome from './components/obrazovanje/LekcijaObrazovanjeHome';
import PodoblastObrazovanjeHome from './components/obrazovanje/PodoblastObrazovanjeHome';
import OblastObrazovanjeHome from './components/obrazovanje/OblastObrazovanjeHome';
import SkupOblastiObrazovanjeHome from './components/obrazovanje/SkupOblastiObrazovanjeHome';
import PodkategorijaObrazovanjeHome from './components/obrazovanje/PodkategorijaObrazovanjeHome';
import KategorijaObrazovanjeHome from './components/obrazovanje/KategorijaObrazovanjeHome';

// QUIZ
import KvizHome from './components/kviz/KvizHome';
import KlasikKvizHome from './components/kviz/klasik-kviz/KlasikKvizHome';
import LovacKvizHome from './components/kviz/LovacKvizHome';
import KvizLovacRangLista from './components/kviz/lovac-kviz/KvizLovacRangLista';

// OTHER
import PuskiceHome from './components/puskice/PuskiceHome';
import PrikazPuskice from './components/puskice/PrikazPuskice';
import { PUSKICE_ENABLED } from './constatnts/FeatureFlags';

import AdminHome from './components/admin/AdminHome';
import KategorijeHome from './components/admin/admin-kategorije/KategorijeHome';
import Podkategorije from './components/admin/admin-kategorije/PodkategorijeHome';
import SkupOblastiHome from './components/admin/admin-kategorije/SkupOblastiHome';
import OblastHome from './components/admin/admin-kategorije/OblastHome';
import SingleOblast from './components/admin/admin-kategorije/SingleOblast';
import MediaHome from './components/media/MediaHome';
import Profile from './components/profile/Profile';
import UserManagement from './components/admin/user-management/UserManagement';
import FinanceCard from './components/admin/user-management/FinanceCard';
import KvizPitanjeManagement from './components/admin/kviz-pitanje-management/KvizPitanjeManagement';

import FullScreenLoader from './components/home/FullScreenLoader';
import PrivacyPolicy from './components/common/PrivacyPolicy';
import TermsAndConditions from './components/common/TermsAndConditions';
import ContactPage from './components/common/ContactPage';
import CookieConsent from './components/common/CookieConsent';

function App() {
    const { setUser, isAdminApp } = useUser();
    useCanonicalSync();

    const [authLoading, setAuthLoading] = useState(true);

    useEffect(() => {
        checkUserAuth();
    }, []);

    const checkUserAuth = async () => {
        const token = localStorage.getItem('accessToken');
        // if (!token) {
        //     setUser({});
        //     setAuthLoading(false);
        //     return;
        // }

        const resp = await whoAmI();

        if (resp?.status === 200) {
            setUser(resp.data);
        } else {
            setUser({});

            localStorage.clear();
        }

        setAuthLoading(false);
    };

    // useEffect(() => {
    //     const prefetch = () => {
    //         import('./components/kviz/klasik-kviz/KlasikKvizHome');
    //         import('./components/kviz/LovacKvizHome');
    //     };

    //     if ('requestIdleCallback' in window) {
    //         console.log('Using requestIdleCallback for prefetching');
    //         requestIdleCallback(prefetch);
    //     } else {
    //         setTimeout(prefetch, 300);
    //     }
    // }, []);

    // if (authLoading) return <FullScreenLoader />;

    // Add a response interceptor
    // axios.interceptors.response.use(
    // 	function (response) {
    // 		// Any status code that lie within the range of 2xx cause this function to trigger
    // 		// Do something with response data
    // 		return response;
    // 	},
    // 	function (error) {
    // 		// Any status codes that falls outside the range of 2xx cause this function to trigger
    // 		// Do something with response error
    // 		let originalRequestConfig = error.response.config;
    // 		if (error.response.status === 401 && !originalRequestConfig._retry) {
    // 			originalRequestConfig._retry = true;
    // 			console.log('response status is 401 ', originalRequestConfig);
    // 			// notif('Istekao je vas token, molim vas prijavite se ponovo');
    // 			logoutUser();
    // 		}
    // 		return Promise.reject(error);
    // 	}
    // );

    return (
        <Suspense fallback={<FullScreenLoader />}>
            <ServerWakeupModal />
            <div className="bg-redA200">
                <Routes>
                    <Route path="/login" element={<PublicRoute Component={LoginScreen} />} />
                    {/* <Route path='/signup' element={<PublicRoute Component={SignUp} />} /> */}
                    <Route path="/verify/email" element={<PublicRoute Component={VerifyAccount} />} />
                    <Route path="/resetPassword" element={<PublicRoute Component={ResetPassword} />} />
                    {!isAdminApp && (
                        <Route path="/" element={<UserHome />}>
                            <Route path="/home" element={<Home />} />
                            <Route path="/user/kategorija" element={<ObrazovanjeHome />} />
                            <Route path="/user/kategorija/:id" Component={KategorijaObrazovanjeHome} />
                            <Route path="/user/podkategorija/:id" Component={PodkategorijaObrazovanjeHome} />
                            <Route path="/user/skup-oblasti/:id" Component={SkupOblastiObrazovanjeHome} />
                            <Route path="/user/oblast/:id" Component={OblastObrazovanjeHome} />
                            <Route path="/user/podoblast/:id" Component={PodoblastObrazovanjeHome} />
                            <Route path="/user/lekcija/:id" Component={LekcijaObrazovanjeHome} />
                            {PUSKICE_ENABLED ? (
                                <>
                                    <Route path="/user/puskice" element={<PrivateRoute Component={PuskiceHome} />} />
                                    <Route path="/user/puskice/:id" element={<PrivateRoute Component={PrikazPuskice} />} />
                                </>
                            ) : (
                                <Route path="/user/puskice/*" element={<Navigate to="/home" replace />} />
                            )}
                            <Route path="/user/kviz/lovac" Component={LovacKvizHome} />
                            <Route path="/user/kviz/lovac/takmicarski" element={<LovacKvizHome samoTakmicarski />} />
                            <Route path="/user/kviz/lovac/rang-lista" Component={KvizLovacRangLista} />
                            <Route path="/user/kviz/klasik" Component={KlasikKvizHome} />
                            <Route path="/user/kviz" Component={KvizHome} />
                            <Route path="/user/privacy" Component={PrivacyPolicy} />
                            <Route path="/user/terms" Component={TermsAndConditions} />
                            <Route path="/user/contact" Component={ContactPage} />
                        </Route>
                    )}
                    {isAdminApp && (
                        <Route path="/" element={<Layout />}>
                            <Route path="admin" element={<PrivateRoute Component={AdminHome} />} />
                            <Route path="admin/kategorije" element={<PrivateRoute Component={KategorijeHome} />} />
                            <Route path="admin/podkategorije" element={<PrivateRoute Component={Podkategorije} />} />
                            <Route path="admin/skup-oblasti" element={<PrivateRoute Component={SkupOblastiHome} />} />
                            <Route path="admin/oblast" element={<PrivateRoute Component={OblastHome} />} />
                            <Route path="admin/oblast/:id" element={<PrivateRoute Component={SingleOblast} />} />
                            <Route path="admin/finance/:id" element={<PrivateRoute Component={FinanceCard} />} />
                            <Route path="admin/usermanagement" element={<PrivateRoute Component={UserManagement} />} />
                            <Route path="admin/kviz-pitanje-management" element={<PrivateRoute Component={KvizPitanjeManagement} />} />

                            <Route path="media" element={<PrivateRoute Component={MediaHome} />} />
                            {/* <Route path='settings' element={<PrivateRoute Component={Settings} />} /> */}
                            <Route path="profile" element={<PrivateRoute Component={Profile} />} />
                        </Route>
                    )}
                    <Route path="*" element={<Navigate to="/home" replace />} />
                </Routes>
                <CookieConsent />
                <Toaster
                    position="top-right"
                    reverseOrder={false}
                    containerStyle={{
                        top: 80,
                    }}
                />
            </div>
        </Suspense>
    );
}

export default App;
